<template>
  <v-dialog
    v-model="dialog"
    v-bind="$props"
    :width="width || ($vuetify.breakpoint.smAndDown ? '100%' : '90%')"
    content-class="cfs-dialog"
  >
    <v-card flat :color="color">
      <v-card-title class="headline white">
        <v-row :align="'center'">
          <v-col cols="12" class="text-center px-0 cfs-dialog-title">
            <div v-if="$hasSlot('title')">
              <slot name="title"></slot>
            </div>
            <div v-else>
              {{ title }}
            </div>
            <v-btn class="mx-2 close-dialog-btn" icon @click="onDismiss()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-0">
        <v-container fluid ma-0 pa-0 center>
          <slot></slot>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  model: {
    prop: 'display',
    event: 'change',
  },
  props: {
    display: {
      type: Boolean,
      default: false,
      required: true,
    },
    color: {
      type: String,
      default: 'white',
      required: false,
    },
    title: {
      type: String,
      default: null,
      required: false,
    },
    width: {
      type: String,
      default: null,
      required: false,
    },
  },
  computed: {
    dialog: {
      get: function () {
        return this.display;
      },
      set: function (nv) {
        this.$emit('update:display', nv);
      },
    },
  },
  methods: {
    onDismiss() {
      this.dialog = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.close-dialog-btn {
  position: absolute;
  right: 0;
  top: 5px;
}
.cfs-dialog-title {
  font-size: 18px;
  font-weight: 500;
}
</style>
